import { Pipe, PipeTransform } from '@angular/core';
import { Language } from '../../models';

@Pipe({
    name: 'language',
})
export class LanguagePipe implements PipeTransform {

    transform(items: any[], language: Language): any {
        if(!items || !language) return items;
        return items.filter(item => item?.language == language);
    }
}
